import { useState, useRef } from "react";
import { Button, Col, Card, CardBody } from "reactstrap";
import { useQuery } from "react-query";
import {
  getHistoryList,
  getTestimonialList,
} from "../../../../../Api/AdminApis";
import CardsWithIcon from "../../../../../Components/Containers/CardWithIcon";
import ModalContainer from "../../../../../Components/Containers/ModalContainer/ModalContainer";
import CustomPagination from "../../../../../Components/Pagination/Pagination";
import DeleteConfirmation from "../../../../../Components/Containers/AlertModal/webistedelete";
import { ScrollToContainerTop } from "../../../../../Utils/helpers/ScrollToContainerTop";
import {
  StatusClickHandler,
  deleteClickHandler,
  modalHandler,
  onEditClickHandler,
} from "./AddHistory/AddHistoryMethods/AddHistoryMethods";
import AddHistory from "./AddHistory";
import { usePermission } from "../../../../../Components/Permissions/Admin/AdminPermission";

const History = () => {
  const myDivRef: any = useRef(null);
  const { checkPermission } = usePermission();
  const [currentPage, setCurrentPage] = useState<string>("1");
  const [isOpen, setIsOpen] = useState(false); // Add doctor modal
  const [modalEditData, setModalEditData] = useState<any>([]); // data for edit modal
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] =
    useState(false);
  const [selectedId, setSelectedId] = useState<string | number>("");

  const {
    data: history,
    error: historyError,
    isLoading: historyLoading,
    refetch: historyListRefetch,
  }: any = useQuery(
    [`history${currentPage}`, currentPage],
    () => getHistoryList(currentPage),
    { keepPreviousData: true }
  );

  const handleDeleteConfirmation = (selectedId: string | number) => {
    setSelectedId(selectedId);
    setIsDeleteConfirmationOpen(true);
  };

  return (
    <>
      <Col lg={12}>
        <Card className="widget-card">
          <CardBody className="widget-inner-wrap">
            <div className="widget-head-outer">
              <div className="widget-heading" ref={myDivRef}>
                <h6>History</h6>
              </div>
              <div className="button-container">
                {checkPermission("website:write") ? <Button
                  onClick={() => modalHandler(setModalEditData, setIsOpen)}
                  color="primary"
                  className="sm"
                  outline
                >
                  <i className="icon icon-add-green xl"></i> Add
                </Button> : null}
              </div>
            </div>
            <CardsWithIcon
              type={"testimonials"}
              data={history?.data}
              tableTitle="History"
              Arraykeys={["title", "body"]}
              viewType="table"
              toURL={"/admin/hh"}
              actions={[
                checkPermission("website:write") ? "edit" : "",
                checkPermission("website:delete") ? "delete" : ""
              ]}
              isLoading={historyLoading}
              error={historyError}
              onEditClick={(selectedId: any) =>
                onEditClickHandler(
                  selectedId,
                  setModalEditData,
                  setIsOpen,
                  history
                )
              }
              onDeleteClick={(selectedId: string | number) =>
                handleDeleteConfirmation(selectedId)
              }
              onStatusClick={(selectedId: string | number, newStatus: any) =>
                StatusClickHandler(selectedId, historyListRefetch, newStatus)
              }
            />
          </CardBody>
        </Card>
      </Col>
      {history?.meta?.total !== 0 && (
        <div className="pagination">
          <CustomPagination
            totalItems={history?.meta?.totalItems}
            itemsPerPage={history?.meta?.itemsPerPage}
            activePage={history?.meta?.currentPage}
            disableScrollAfterPageChange
            setCurrentPage={(pageNo: string) => {
              ScrollToContainerTop(myDivRef);
              setCurrentPage(pageNo);
            }}
          />
        </div>
      )}
      <ModalContainer
        isOpen={isOpen}
        setIsopen={setIsOpen}
        title="Add  History"
      >
        <AddHistory
          setIsOpen={setIsOpen}
          refetch={historyListRefetch}
          modalEditData={modalEditData}
        />
      </ModalContainer>

      <DeleteConfirmation
        isOpen={isDeleteConfirmationOpen}
        setIsOpen={setIsDeleteConfirmationOpen}
        onDelete={() => {
          deleteClickHandler(selectedId, historyListRefetch);
          setIsDeleteConfirmationOpen(false);
        }}
      />
    </>
  );
};

export default History;
